// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Attachment Preview Modal Styles */

.attachment-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}

.attachment-modal-content {
  background: #ffffff;
  border-radius: 8px;
  width: 90%;
  max-width: 1200px;
  height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.attachment-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e0e0e0;
  background: #f8f9fa;
}

.attachment-modal-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  min-width: 0;
}

.attachment-modal-info h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.attachment-modal-size {
  font-size: 13px;
  color: #666;
  padding: 2px 8px;
  background: #e9ecef;
  border-radius: 4px;
  flex-shrink: 0;
}

.attachment-modal-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.attachment-modal-download-btn,
.attachment-modal-close-btn {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 6px;
  background: #fff;
  color: #333;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  border: 1px solid #dee2e6;
}

.attachment-modal-download-btn:hover {
  background: #28a745;
  color: white;
  border-color: #28a745;
}

.attachment-modal-close-btn:hover {
  background: #dc3545;
  color: white;
  border-color: #dc3545;
}

.attachment-modal-body {
  flex: 1 1;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
}

.attachment-modal-loading,
.attachment-modal-error,
.attachment-modal-unsupported {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px;
  text-align: center;
}

.attachment-modal-loading .spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e0e0e0;
  border-top-color: #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.attachment-modal-loading p,
.attachment-modal-error p,
.attachment-modal-unsupported p {
  margin: 0;
  color: #666;
  font-size: 14px;
}

.attachment-modal-error .error-icon {
  font-size: 48px;
}

.attachment-modal-unsupported .unsupported-icon {
  font-size: 64px;
}

.attachment-modal-download-btn-large {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  background: #28a745;
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
  margin-top: 8px;
}

.attachment-modal-download-btn-large:hover {
  background: #218838;
}

/* Image Preview */
.attachment-modal-image-preview {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.attachment-modal-image-preview img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* PDF Preview */
.attachment-modal-iframe-preview {
  width: 100%;
  height: 100%;
}

.attachment-modal-iframe-preview iframe {
  border: none;
  background: white;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .attachment-modal-content {
    width: 95%;
    height: 95vh;
  }

  .attachment-modal-header {
    padding: 12px 16px;
  }

  .attachment-modal-info h3 {
    font-size: 14px;
  }

  .attachment-modal-size {
    font-size: 12px;
  }

  .attachment-modal-download-btn,
  .attachment-modal-close-btn {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/css/AttachmentPreviewModal.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;;EAGE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":["/* Attachment Preview Modal Styles */\n\n.attachment-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  padding: 20px;\n}\n\n.attachment-modal-content {\n  background: #ffffff;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 1200px;\n  height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n}\n\n.attachment-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e0e0e0;\n  background: #f8f9fa;\n}\n\n.attachment-modal-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  min-width: 0;\n}\n\n.attachment-modal-info h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.attachment-modal-size {\n  font-size: 13px;\n  color: #666;\n  padding: 2px 8px;\n  background: #e9ecef;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n\n.attachment-modal-actions {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.attachment-modal-download-btn,\n.attachment-modal-close-btn {\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: 6px;\n  background: #fff;\n  color: #333;\n  font-size: 18px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  border: 1px solid #dee2e6;\n}\n\n.attachment-modal-download-btn:hover {\n  background: #28a745;\n  color: white;\n  border-color: #28a745;\n}\n\n.attachment-modal-close-btn:hover {\n  background: #dc3545;\n  color: white;\n  border-color: #dc3545;\n}\n\n.attachment-modal-body {\n  flex: 1;\n  overflow: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f5f5f5;\n}\n\n.attachment-modal-loading,\n.attachment-modal-error,\n.attachment-modal-unsupported {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 40px;\n  text-align: center;\n}\n\n.attachment-modal-loading .spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #e0e0e0;\n  border-top-color: #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.attachment-modal-loading p,\n.attachment-modal-error p,\n.attachment-modal-unsupported p {\n  margin: 0;\n  color: #666;\n  font-size: 14px;\n}\n\n.attachment-modal-error .error-icon {\n  font-size: 48px;\n}\n\n.attachment-modal-unsupported .unsupported-icon {\n  font-size: 64px;\n}\n\n.attachment-modal-download-btn-large {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  background: #28a745;\n  color: white;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s ease;\n  margin-top: 8px;\n}\n\n.attachment-modal-download-btn-large:hover {\n  background: #218838;\n}\n\n/* Image Preview */\n.attachment-modal-image-preview {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.attachment-modal-image-preview img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* PDF Preview */\n.attachment-modal-iframe-preview {\n  width: 100%;\n  height: 100%;\n}\n\n.attachment-modal-iframe-preview iframe {\n  border: none;\n  background: white;\n}\n\n/* Mobile Responsiveness */\n@media (max-width: 768px) {\n  .attachment-modal-content {\n    width: 95%;\n    height: 95vh;\n  }\n\n  .attachment-modal-header {\n    padding: 12px 16px;\n  }\n\n  .attachment-modal-info h3 {\n    font-size: 14px;\n  }\n\n  .attachment-modal-size {\n    font-size: 12px;\n  }\n\n  .attachment-modal-download-btn,\n  .attachment-modal-close-btn {\n    width: 32px;\n    height: 32px;\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
